import { useEffect, useState } from 'react'

/**
 * Holds a value still for `delayMs` after it last changed.
 *
 * Applied to the amount field, which is the difference between one quote per trade size and
 * one per keystroke. The API's per-client budget is 5 rps sustained (`rateLimit.perClientRps`)
 * and a quote costs the node dozens of simulated swaps, so an undebounced input burns the
 * bucket and gets the user 429s on the amount they actually meant.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
